import { render, staticRenderFns } from "./LmPricingTable.vue?vue&type=template&id=534ea5c5&scoped=true&"
import script from "./LmPricingTable.vue?vue&type=script&lang=js&"
export * from "./LmPricingTable.vue?vue&type=script&lang=js&"
import style0 from "./LmPricingTable.vue?vue&type=style&index=0&id=534ea5c5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534ea5c5",
  null
  
)

export default component.exports